module.exports = __webpack_public_path__ + "static/fonts/PorscheNextArabicTT-Regular.57bf4b9d.ttf";